var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-wrapper",
    class: {
      'design-time-bottom-margin': !!this.designer
    },
    style: ({
      display: _vm.displayStyle
    })
  }, [(!_vm.field.options.hidden || (_vm.designState === true)) ? _c('div', {
    staticClass: "static-content-item",
    class: [_vm.selected ? 'selected' : '', _vm.customClass],
    style: ({
      display: _vm.displayStyle
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectField(_vm.field)
      }
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (!!this.designer) ? [(_vm.designer.selectedId === _vm.field.id) ? _c('div', {
    staticClass: "field-action"
  }, [_c('i', {
    staticClass: "el-icon-back",
    attrs: {
      "title": _vm.i18nt('designer.hint.selectParentWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectParentWidget(_vm.field)
      }
    }
  }), _vm._v(" "), (!!_vm.parentList && (_vm.parentList.length > 1)) ? _c('i', {
    staticClass: "el-icon-top",
    attrs: {
      "title": _vm.i18nt('designer.hint.moveUpWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.moveUpWidget(_vm.field)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!!_vm.parentList && (_vm.parentList.length > 1)) ? _c('i', {
    staticClass: "el-icon-bottom",
    attrs: {
      "title": _vm.i18nt('designer.hint.moveDownWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.moveDownWidget(_vm.field)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-copy-document",
    attrs: {
      "title": _vm.i18nt('designer.hint.cloneWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cloneField(_vm.field)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-delete",
    attrs: {
      "title": _vm.i18nt('designer.hint.remove')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeFieldWidget.apply(null, arguments)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.designer.selectedId === _vm.field.id) ? _c('div', {
    staticClass: "drag-handler background-opacity"
  }, [_c('i', {
    staticClass: "el-icon-rank",
    attrs: {
      "title": _vm.i18nt('designer.hint.dragHandler')
    }
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.i18n2t(("designer.widgetLabel." + (_vm.field.type)), ("extension.widgetLabel." + (_vm.field.type)))))]), _vm._v(" "), (_vm.field.options.hidden === true) ? _c('i', {
    staticClass: "iconfont icon-hide"
  }) : _vm._e()]) : _vm._e()] : _vm._e()], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c41a02c4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/static-content-wrapper.vue
// module id = null
// module chunks = 